import { render, staticRenderFns } from "./priceTab.vue?vue&type=template&id=5645b064&scoped=true&"
import script from "./priceTab.vue?vue&type=script&lang=js&"
export * from "./priceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645b064",
  null
  
)

export default component.exports